import http from "../http"; // ایمپورت کردن اینستنس مرکزی خودت
// ✅ ساخت کاربر جدید توسط ادمین
export const createUser = async (userData) => {
  try {
    // چون در http.js احتمالاً BaseURL داری، اینجا فقط مسیر نسبی رو می‌نویسیم
    // اگر در http.js بیس یو آر ال تا انتهای /api/auth هست، اینجا فقط بنویس "create-user/"
    const response = await http.post("/auth/create-user/", userData);
    return response.data;
  } catch (error) {
    // مدیریت خطا بر اساس ساختار ارورهای جنگو
    throw error.response?.data || { error: "خطای شبکه یا سرور" };
  }
};

// ✅ لیست کاربران (برای آینده)

export async function getUsers(role) {
  const res = await http.get("/auth/users/", {
    params: role ? { role } : {},
  });
  console.log("API RESULT => ", res.data); // این خیلی مهمه
  return res.data;
}

export const toggleUserActive = (userId) => {
  return http.post(`/auth/admin/users/${userId}/toggle-active/`);
};

export const updateUser = (userId, data) => {
  return http.put(`/auth/admin/users/${userId}/edit/`, data);
};
